export const PESQUISA_DOCUMENTOS = 'PESQUISA_DOCUMENTOS';
export const PESQUISA_DOCUMENTOS_START = 'PESQUISA_DOCUMENTOS_START';
export const PESQUISA_DOCUMENTOS_ERROR = 'PESQUISA_DOCUMENTOS_ERROR';
export const PESQUISA_DOCUMENTOS_SUCCESS = 'PESQUISA_DOCUMENTOS_SUCCESS';

export const FILTRAR_DOCUMENTOS = 'FILTRAR_DOCUMENTOS';
export const RESETAR_DOCUMENTOS = 'RESETAR_DOCUMENTOS';
